"use strict";

var autocompleteDropdown = require('./components/autocompleteDropdown');
var formHelpers = require('./checkout/formErrors');

var ADD_NEW_SCHOOL_MODAL = '#addNewSchoolModal';
var SELECTOR_ADDNEWSCHOOL_STEP_DESC_ERROR = '.addnewschool-step-description-error';
var CSS_IS_INVALID = 'is-invalid';
var CSS_AUTO_MATCHES = 'auto-matches';
var EVENT_AUTOCOMPLETE_OFF = 'menufocus hover mouseover mouseenter';
var SELECTOR_SCHOOLCITY_LIST_RESULT = '.schoolcity-list-result';
var SELECTOR_SEARCHED_PROVINCE_LIST = '#searched-schoolprovince-list';
var ATTR_ARIA_INVALID = 'aria-invalid';
var STATUS_SUCCESS = 'success';
var CSS_D_NONE = 'd-none';
var CSS_SHOW = 'show';
var AUTOCOMPLETE_WIDGET = 'widget';

function clearPreviousErrors() {
    var addSchoolModalId = $('#createAccountModal:visible').length ? '#createAccountModal' : ADD_NEW_SCHOOL_MODAL;
    formHelpers.clearPreviousErrors(addSchoolModalId);
    $(SELECTOR_ADDNEWSCHOOL_STEP_DESC_ERROR).addClass(CSS_D_NONE);
}

function step1FindSchoolListByPostalCode(element, input, selectedProvince, selectedCity, loadingEle) {
    $(loadingEle).spinner().start();

    var url = $(element).data('findSchools'),
        selectedPostalCodeVal = $(input).val(),
        selectedProvinceVal = $(selectedProvince).val(),
        selectedCityVal = $(selectedCity).val(),
        data = {"format": "ajax", "postalCode": selectedPostalCodeVal}; // NOSONAR

    // update the Request URL & Data in case of Province & City
    if (!selectedPostalCodeVal && (selectedProvinceVal && selectedCityVal)) {
        data = {"format": "ajax", "province": selectedProvinceVal, "city": selectedCityVal}; // NOSONAR
    }

	$.ajax({
        url: url,
        type: 'get',
        data: data,
        success: function(data) {
            if(data.status === STATUS_SUCCESS && data.schools.length) {
                $('.addnewschool-step-1').addClass(CSS_D_NONE);
                $('.addnewschool-step-2').removeClass(CSS_D_NONE);
                $('.selected-filter').html(selectedPostalCodeVal ? selectedPostalCodeVal : selectedCityVal + ', ' + selectedProvinceVal); // NOSONAR
                clearPreviousErrors();
                $('.next-addnewschool').attr('disabled', true);
                // bind school list drop down
                bindList('schoolModal', data);

                // custom dropdown handling
                autocompleteDropdown('schoolModal', 'addnewschool-dropdown-schoolModal');
            } else {
                $(SELECTOR_ADDNEWSCHOOL_STEP_DESC_ERROR).removeClass(CSS_D_NONE);
                $(input).addClass(CSS_IS_INVALID);
            }
            $.spinner().stop();
        }, error: function() {
            $.spinner().stop();
        }
    });
}

function getSelectedSchoolDetail(element, schoolId, loadingEle) {
    $(loadingEle).spinner().start();
    $.ajax({
        url: $(element).data('schoolsDetail'),
        type: 'get',
        data:{"format": "ajax", "schoolId": schoolId}, // NOSONAR
        success: function (data) {
            if(data.status === STATUS_SUCCESS) {
                $('.addnewschool-step-2').addClass(CSS_D_NONE);
                $('.addnewschool-step-3').removeClass(CSS_D_NONE);
                var schoolJson = data.schoolJson;
                $('.addnewschool_selectedSchool_id').val(schoolJson.schoolId);
                $('.selected-school').html(
                    '<span>' + schoolJson.companyName + '</span>' + // NOSONAR
                    '<span>' + schoolJson.address1 + '</span>' +
                    '<span>' + schoolJson.address2 + '</span>' +
                    '<span>' + schoolJson.city + ', '+ schoolJson.stateCode + '</span>' +
                    '<span>' + schoolJson.postalCode + '</span>' +
                    '<span>' + schoolJson.phone + '</span>'
                );

                $.spinner().stop();
            }
        }, error: function() {
            $.spinner().stop();
        }
    });
}

function bindList(modalType, data) {
    var list = data.schools;
    if (list) {
        $('#addnewschool-dropdown-' + modalType).val('');
        $('#addnewschool-dropdown-' + modalType)
        .autocomplete({
            source: function (request, response) {
                var matches = list;
                if (request.term) {
                    matches = $.map(list, function (acItem) {
                        if (acItem.value.toUpperCase().indexOf(request.term.trim().toUpperCase()) === 0) {
                            return acItem;
                        }
                        return undefined;
                    });
                }
                response(matches);
            },
            appendTo: $('.addnewschool-search-result.' + modalType),
            highlightClass: CSS_AUTO_MATCHES,
            open: function() {
                $(this).autocomplete(AUTOCOMPLETE_WIDGET).off(EVENT_AUTOCOMPLETE_OFF);
                $(this).attr('autocomplete', modalType + '-dropdown');
            },
            minLength:0,
            scroll:true,
            select: function(event, ui) {
                event.stopPropagation();
                $('.addnewschool_selected_id.' + modalType).val(ui.item.key);
                $('.addnewschool_selected_text.' + modalType).val(ui.item.value);
                $('.next-addnewschool.' + modalType).removeAttr('disabled');
                $(this).autocomplete(AUTOCOMPLETE_WIDGET).removeClass(CSS_SHOW);
            }
        })
        .focus(function () {
            $(this).autocomplete("search", "");
        })
        .autocomplete( "instance" )._renderItem = function( ul, item ) {
            const $li = $( "<li/>" ).text( item.value );  // Fastest rendering
            if (!item.value) {
                $li.addClass(CSS_D_NONE);
            }
            return $li.appendTo(ul);
        };
    }
}

/**
 * @function
 * @description open and close the autocomplete dropdown as per given parameter parentEle and inputEle
 * @param {String} element, common pre and post fix class for clicked and shown container
 * @param {String} element1, common pre and post fix class for nested step header
 * @param {Boolean} nestedStep, to handle step indicator
 * @classes will be e.g. '#element-input, #element-input-error, .element-currentstep, .element-steps, .element-step-description-error, .element-step-1, .element-step-description'
 */
function resetStep1Modal(element, element1, nestedStep) {
    clearPreviousErrors();
    // Below 2 lines for provice n city
    $('.resetValue').val('');
    $(SELECTOR_SCHOOLCITY_LIST_RESULT).addClass(CSS_D_NONE);

    // element1 is for if user has nested steps e.g. create account step 3 has nested steps
    if (!element1) {
        element1 = element;
    }
    var input = '#' + element1;
    var elementClass = '.' + element;
    var element1Class = '.' + element1;

    $(input + '-input').val('').removeClass(CSS_IS_INVALID);
    $(input + '-input-error').remove();
    $('.search-' + element1).attr('disabled', 'disabled');
    $(element1Class + '-steps').addClass(CSS_D_NONE);
    $(elementClass + '-step-description-error').addClass(CSS_D_NONE);
    $(element1Class + '-step-1').removeClass(CSS_D_NONE);

    if ($(elementClass + '-step-description').length) {
        $(elementClass + '-step-description').removeClass(CSS_D_NONE);
    }
}

/**
 * @function
 * @description bind the city list and init autocomplete
 * @param {String} list, city list
 * @param {String} searchSchoolBtn, search button
 * @param {String} cityDropdown, city dropdown
 */
function bindCityList(list, searchSchoolBtn, cityDropdown) {
    if (list) {
        $(cityDropdown).val('');
        $(cityDropdown)
        .autocomplete({
            source: function (request, response) {
                var matches = list;
                if (request.term) {
                    matches = $.map(list, function (acItem) {
                        if (acItem.value.toUpperCase().indexOf(request.term.trim().toUpperCase()) === 0) {
                            return acItem;
                        }
                        return undefined;
                    });
                }
                response(matches);
            },
            appendTo: $(SELECTOR_SCHOOLCITY_LIST_RESULT),
            highlightClass: CSS_AUTO_MATCHES,
            open: function() {
                $(this).autocomplete(AUTOCOMPLETE_WIDGET).off(EVENT_AUTOCOMPLETE_OFF);
                $(this).attr('autocomplete', 'city-dropdown');
            },
            minLength: 0,
            scroll: true,
            select: function(event, ui) {
                event.stopPropagation();
                $('.schoolcity_id').val(ui.item.key);
                clearPreviousErrors();
                $(this).autocomplete(AUTOCOMPLETE_WIDGET).removeClass(CSS_SHOW);
                $(searchSchoolBtn).removeAttr('disabled');
            }
        })
        .focus(function (event, ui) {
            $(this).autocomplete("search", "");
        })
        .autocomplete( "instance" )._renderItem = function( ul, item ) {
            const $li = $( "<li/>" ).text( item.value );  // Fastest rendering
            return $li.appendTo(ul);
        };
    }
}

/**
 * @function
 * @description bind the province list and init autocomplete
 * @param {String} searchSchoolBtn, search button
 * @param {String} schoolZipCodeInput, search input
 * @param {String} provinceDropdown, province dropdown
 * @param {String} cityDropdown, city dropdown
 * @param {String} loadingEle, Div to show loader
 * @param {String} notAssoWithSchoolCheckbox, checkbox only for profile page
 */
function bindProvinceList(searchSchoolBtn, schoolZipCodeInput, provinceDropdown, cityDropdown, loadingEle, clickedEle, notAssoWithSchoolCheckbox) {
    var list = $(SELECTOR_SEARCHED_PROVINCE_LIST).val();
    var cityUrl = $(clickedEle).data('cityUrl');
    if (list) {
        list = JSON.parse(list);
        if ($(provinceDropdown).length) {
            $(provinceDropdown).val('');
            $(provinceDropdown)
                .autocomplete({
                    source: function (request, response) {
                        var matches = list;
                        if (request.term) {
                            matches = $.map(list, function (acItem) {
                                if (acItem.value.toUpperCase().indexOf(request.term.trim().toUpperCase()) === 0) {
                                    return acItem;
                                }
                                return undefined;
                            });
                        }
                        response(matches);
                    },
                    appendTo: $('.schoolprovince-list-result'),
                    highlightClass: CSS_AUTO_MATCHES,
                    open: function() {
                        $(this).autocomplete(AUTOCOMPLETE_WIDGET).off(EVENT_AUTOCOMPLETE_OFF);
                        $(this).attr('autocomplete', 'province-dropdown');
                    },
                    minLength: 0,
                    scroll: true,
                    select: function(event, ui) {
                        event.stopPropagation();
                        $('.schoolprovince_id').val(ui.item.key);
                        clearPreviousErrors();
                        $(this).autocomplete(AUTOCOMPLETE_WIDGET).removeClass(CSS_SHOW);
                        $(loadingEle).spinner().start();
                        $.ajax({
                            url: cityUrl,
                            type: "get",
                            data: {"format": "ajax","province": ui.item.key}, // NOSONAR
                            success: function (data) {
                                if(data.status === STATUS_SUCCESS) {
                                    $(schoolZipCodeInput).val('').removeClass(CSS_IS_INVALID).attr(ATTR_ARIA_INVALID, false);
                                    $(schoolZipCodeInput).siblings('.is-invalid').remove();

                                    $(searchSchoolBtn).attr('disabled','disabled');
                                    if ($(cityDropdown).data('ui-autocomplete')) {
                                        $(cityDropdown).autocomplete("destroy");
                                    }
                                    bindCityList(data.cityList, searchSchoolBtn, cityDropdown);
                                    // custom dropdown handling
                                    autocompleteDropdown('schoolcity-list-result', 'schoolcity-dropdown');
                                    $(SELECTOR_SCHOOLCITY_LIST_RESULT).removeClass(CSS_D_NONE);
                                    $.spinner().stop();
                                }
                            },
                            error: function() {
                                $.spinner().stop();
                            }
                        });
                    }
                })
                .focus(function () {
                    $(this).autocomplete("search", "");
                })
                .autocomplete( "instance" )._renderItem = function( ul, item ) {
                    const $li = $( "<li/>" ).text( item.value );  // Fastest rendering
                    return $li.appendTo(ul);
                };
        }
    }
}

/**
 * @function
 * @description bind the province list and init autocomplete
 * @param {String} searchSchoolBtn, search button
 * @param {String} schoolZipCodeInput, search input
 * @param {String} provinceDropdown, province dropdown
 * @param {String} cityDropdown, city dropdown
 * @param {String} loadingEle, Div to show loader
 * @param {String} notAssoWithSchoolCheckbox, checkbox only for profile page
 */
function getProvinceList(searchSchoolBtn, schoolZipCodeInput, provinceDropdown, cityDropdown, loadingEle, clickedEle, notAssoWithSchoolCheckbox) {
    if (!$(SELECTOR_SEARCHED_PROVINCE_LIST).val()) {
        $(loadingEle).spinner().start();
        $.ajax({
            url: $(clickedEle).data('province-url'),
            type: 'get',
            success: function (data) {
                if(data.status === STATUS_SUCCESS) {
                    $(SELECTOR_SEARCHED_PROVINCE_LIST).val(JSON.stringify(data.provinceList));
                    $.spinner().stop();
                    bindProvinceList(searchSchoolBtn, schoolZipCodeInput, provinceDropdown, cityDropdown, loadingEle, clickedEle, notAssoWithSchoolCheckbox);
                    // custom dropdown handling
                    autocompleteDropdown('schoolprovince-list-result', 'schoolprovince-dropdown');
                } else {
                    $.spinner().stop();
                }
            },
            error: function() {
                $.spinner().stop();
            }
        });
    } else {
        bindProvinceList(searchSchoolBtn, schoolZipCodeInput, provinceDropdown, cityDropdown, loadingEle, clickedEle, notAssoWithSchoolCheckbox);
        // custom dropdown handling
        autocompleteDropdown('schoolprovince-list-result', 'schoolprovince-dropdown');
    }
}

function postalCodeValidate(postal, button) {
    var canPostCode = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}\s\d{1}[A-Z]{1}\d{1}$/,
        validatePostalCode = $(postal).val().toUpperCase().replace(/\W/g,'').replace(/(...)/,'$1 ');
    if(canPostCode.exec(validatePostalCode)){
        $(button).removeAttr('disabled');
        $(postal).removeClass(CSS_IS_INVALID).attr(ATTR_ARIA_INVALID, false);
        $(postal).val(function(){
            return validatePostalCode;
        })
    } else {
        $(button).attr('disabled','disabled');
        $(postal).addClass(CSS_IS_INVALID).attr(ATTR_ARIA_INVALID, true);
    }
}

/**
 * @function
 * @description open and close the autocomplete dropdown as per given parameter parentEle and inputEle
 * @param {String} element, common pre and post fix class for clicked and shown container
 * @classes will be e.g. '.back-element, .element-steps, .element-step, .element-currentstep'
 */
function goToBackStepModal(element) {
    $('.back-' + element).on('click', function() {
        var stepBackNo = $(this).data('stepback');
        $('.' + element + '-steps').addClass(CSS_D_NONE); // NOSONAR
        $('.' + element + '-step-' + stepBackNo).removeClass(CSS_D_NONE); // NOSONAR
    });
}

/**
 * @function
 * @description open and close the autocomplete dropdown as per given parameter parentEle and inputEle
 * @param {String} element, common pre and post fix class for clicked and shown container
 * @classes will be e.g. '.element-currentstep, .element-steps, .element-step'
 */
function goToBackStepHeaderModal(element) {
    $('.' + element + '-currentstep span.semiactive').on('click', function() { // NOSONAR
        var clickedStep = $(this).data('step'),
            stepBack =  $('.' + element + '-steps:not(".d-none")').find('.back-' + element).data('stepback'); // NOSONAR
        if ( clickedStep > stepBack) {
            return; // don't do anything if clicked on current step
        } else if ( clickedStep === stepBack) { // if click on immediate back one
            $('.' + element + '-step-' + (stepBack+1)).find('.back-' + element).trigger('click'); // NOSONAR
        } else { // if click any other instead of immediate back one
            $('.' + element + '-step-' + (clickedStep + 1)).find('.back-' + element).trigger('click'); // NOSONAR
        }
    });
}

var initializeEvents = function() {
    // School Zip Code
	var searchSchoolBtn = $('.search-addnewschool'),
        schoolZipCodeInput = $('#addnewschool-input'),
        provinceDropdown = $('#schoolprovince-dropdown'),
        cityDropdown = $('#schoolcity-dropdown'),
        selectedProvince = $('.schoolprovince_id'),
        selectedCity = $('.schoolcity_id'),
        loadingEle = $(ADD_NEW_SCHOOL_MODAL + ' .modal-content');

    $('.add-another-school').on('click',function (e) {
        addnewschoolClickEvent(e.currentTarget);
    });

    if ($('#createAccountModal').length) {
        const clickedEle = $('#addSchoolBtn');
        loadingEle = $("#createAccountModal .modal-content");
        // get Province List
        getProvinceList(searchSchoolBtn, schoolZipCodeInput, provinceDropdown, cityDropdown, loadingEle, clickedEle);
    }

    function addnewschoolClickEvent(clickedEle) {
        // Reset Step 1
        resetStep1Modal('addnewschool');
        $(ADD_NEW_SCHOOL_MODAL).modal({keyboard: false, backdrop: 'static'}); // open the modal

        // get Province List
        getProvinceList(searchSchoolBtn, schoolZipCodeInput, provinceDropdown, cityDropdown, loadingEle, clickedEle);
    }

    $('.addnewschool-new-search').on('click', function() {
        resetStep1Modal('addnewschool');
    });

    $(schoolZipCodeInput).on('input blur', function() {
        // Reset Province & City
        var trimVal = $(schoolZipCodeInput).val() ? $(schoolZipCodeInput).val().trim() : '';
		if (trimVal) {
            if (trimVal.length > 3) {
                $(schoolZipCodeInput).val(trimVal.toUpperCase().replace(/\W/g,'').replace(/(...)/,'$1 '));
            } else {
                $(schoolZipCodeInput).val(trimVal.toUpperCase());
            }

			$('.resetValue').val('');
			$(provinceDropdown, cityDropdown).removeClass(CSS_IS_INVALID).attr(ATTR_ARIA_INVALID, false);
			$(provinceDropdown, cityDropdown).siblings('.is-invalid').remove();
			$(SELECTOR_SCHOOLCITY_LIST_RESULT).addClass(CSS_D_NONE);
            $(SELECTOR_ADDNEWSCHOOL_STEP_DESC_ERROR).addClass(CSS_D_NONE);
		}
    });

    // Step 1: Get School List by Postal Code
	$(searchSchoolBtn).on('click', function() {
        step1FindSchoolListByPostalCode(this, schoolZipCodeInput, selectedProvince, selectedCity, loadingEle);
	});

    // Step 2: Get Teacher List by School Code
    $('.next-addnewschool.schoolModal').on('click', function() {
        var schoolId = $('.addnewschool_selected_id.schoolModal').val();
        getSelectedSchoolDetail(this, schoolId, loadingEle);
    });

    // Final: Close the modal & Apply Class Code
    $('.apply-addnewschool').on('click', function(e) {
        var schoolId = $('.addnewschool_selectedSchool_id').val();
        const pageType = $('.account-page').length ? 'account' : 'checkout';
        $.ajax({
            url: $(e.target).data('addSchool'),
            type: 'post',
            data:{"format": "ajax", "schoolId": schoolId, "pageType": pageType}, // NOSONAR
            success: function(data) {
                if(data.status === STATUS_SUCCESS) {
                    if (pageType === "checkout") {
                        window.location.reload();
                    } else {
                        if (data.schoolHtml) {
                            $('.school-association-options').append(data.schoolHtml);
                        }
                        $('#schoolAddr_' + schoolId).prop('checked', true).trigger('change');
                        $(ADD_NEW_SCHOOL_MODAL).modal('hide');
                        $('.no-school-msg').addClass(CSS_D_NONE);
                    }
                }
                $.spinner().stop();
            }, error: function(data) {
                if ("redirectUrl" in data.responseJSON) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $.spinner().stop();
                }
            }
        });
    });

    // Back Button
    goToBackStepModal('addnewschool');

    // Step Header Click Event
    goToBackStepHeaderModal('addnewschool');
};

var addNewSchool = {
    init: initializeEvents
};

module.exports = addNewSchool;
